import { useMutation, useQueryClient } from "react-query";

import { TSDate } from "foundation-ts/tsdate";
import { UUID } from "foundation-ts/types";

import { SectionsListQueryID } from "@hooks/hooksConstants";
import { patchToBeSignedSession } from "@services/session.service";

type UpdateSessionInput = {
    sessionId: UUID;
    newDate: TSDate;
};

const useUpdateToBeSignedSession = () => {
    const queryClient = useQueryClient();
    return useMutation(
        {
            mutationFn: ({ sessionId, newDate }: UpdateSessionInput) => patchToBeSignedSession(sessionId, newDate),
            onSuccess: () => {
                // A la mise à jour d'une session, on récupère les sessions
                queryClient.invalidateQueries(SectionsListQueryID);
            },
        }
    );
};

export default useUpdateToBeSignedSession;